import $ from 'jquery'
import _ from 'lodash'
import M from 'materialize-css'
import zxcvbn from 'zxcvbn'
import SignaturePad from "signature_pad";
import checkPassword from "./password_check";
// import pdfjsLib  from 'pdfjs-dist'

function makeRow(value, key = null) {
  let td = '';
  if(key) {
    td = '<td><b>' + key + '</b></td><td>'+ value + '</td>'
  } else {
    td = '<td colspan="2"><b>' + value + '</b></td>'
  }
  return '<tr>' + td + '</tr>'

}
function getBase64(file, callback) {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    callback(reader.result);
  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
}

function api(link, data, cb) {
  $.ajax({
    beforeSend: function (request) {
      request.setRequestHeader("Accept", 'application/json')
    },
    type: "POST",
    data: data,
    url: BASE_URL + "/" + link,
    success: function (resp) {
      return cb(resp)
    },
    error: function (resp) {
      return cb(resp.responseJSON)
    },
  })
}

window.$ = $;

var signaturePad;
var loading_processor = false;
var loading_agreement = false;
var base64 = null;
var pdfUrl = '';
var mode = 'draw';
// var base64pdf = null;
var kvkCompanies = [];
var kvk = null;

class Wizard {
  constructor($el) {
    this.$el = $el;
    this.current_step = 1;
    this.total_steps = this.$el.find('.step-tab-panel').length + 1;
    this.validated_steps = [];
    this.step_actions = {};
    this.step_validations = {};

    _.bindAll(this, 'next', 'prev', 'addStepAction');

    this.$el.find('.btn-previous').on('click', this.prev);
    this.$el.find('.btn-next').on('click', this.next);
    this.moved();

  }

  next() {
    var _next = () => {
      if (this.isValid(this.current_step)) {

        this.$el.find('.step-tab-panel, .step-steps > li').removeClass('active');
        this.$el.find('.step-tab-panel[data-step="' + (this.current_step + 1) + '"], .step-steps > li[data-step="' + (this.current_step + 1) + '"]').addClass('active')
        this.current_step++;
        // debugger
        if (this.step_actions['step' + this.current_step]) {
          this.step_actions['step' + this.current_step]();
        }
        this.moved()
      }
    };
    if (this.step_validations['step' + this.current_step]) this.step_validations['step' + this.current_step](_next);
    else _next();

  }

  prev() {
    this.$el.find('.step-tab-panel, .step-steps > li').removeClass('active');
    this.$el.find('.step-tab-panel[data-step="' + (this.current_step - 1) + '"], .step-steps > li[data-step="' + (this.current_step - 1) + '"]').addClass('active')
    this.current_step--;
    this.moved()
  }

  isValid(step) {
    return this.validated_steps.indexOf(step) !== -1
  }

  setValid(step) {
    this.validated_steps.push(step)
  }

  moved() {
    var $prev = this.$el.find('.btn-previous'),
      $next = this.$el.find('.btn-next'),
      $cur_step_panel = this.$el.find('.step-tab-panel[data-step="' + this.current_step + '"]'),
      has_actions = false;
    if (this.current_step !== 1) {
      $prev.show();
      has_actions = true
    } else {
      $prev.hide()
    }
    if(this.current_step === 5) {
      $('.finish').show();
    } else {
      $('.finish').hide();
    }
    if ($cur_step_panel.attr('data-show-next') && this.current_step !== this.total_steps) {
      $next.show();
      has_actions = true
    } else {
      $next.hide();
    }
    this.$el.find('.card-action').toggle(has_actions)

  }

  addStepAction(step, stepAction) {
    this.step_actions['step' + step] = stepAction.bind(window.wizard);
  }

  addStepValidation(step, stepValidation) {
    this.step_validations['step' + step] = stepValidation.bind(window.wizard);
  }
}


function formatKvKEntry(entry) {

  var name = entry.tradeNames.businessName ? entry.tradeNames.businessName : 'Naam onbekend';
  var addressFormatted = 'Adres onbekend';
  if(!entry.addresses) return false;
  if (entry.addresses[0]) {
    var a = entry.addresses[0]
    addressFormatted = a.street + ' ' + a.houseNumber + a.houseNumberAddition + ', ' + a.postalCode + ' ' + a.city
  }
  return name + ' | ' + addressFormatted
}

function getAddressPart(entry, part) {
  if (entry.addresses[0]) return entry.addresses[0][part];
  return '';
}

function showValidation(errors) {
  $('#kvk-select').html('');
  $('.helper').remove();
  $('.invalid').removeClass('invalid');
  $.each(errors, function (i, err) {
    if (err.field) {
      i = err.field;
      err = err.message;
    }
    var $row = $('#' + i).parent();

    if ($row.length) {
      if (!$row.find('.helper').length) {
        $row.append('<span class="helper invalid"></span>');
      }
      const $helper = $row.find('.helper');
      $row.find('input').addClass('invalid');
      let html = '';
      if(typeof err === 'string') {
        html = err;
      } else if(err.length === 1) {
        html = err[0];
      } else {
        $.each(err, function (i, e) {
          html += '- ' + e + '<br>';
        });
      }
      $helper.html(html);
      if(i === 'kvk') {
        $('#kvk-select').html(html);
      }
    }
  })
}

$.fn.serializeObject = function () {
  let o = {};
  let a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};

$(() => {
  // $('#steps').steps({
  //   onFinish: function () { alert('Wizard Completed'); }
  // });
  window.wizard = new Wizard($('#steps'));

  window.wizard.addStepAction(2, function () {
    var $list = this.$el.find('#company-choices');
    this.$el.find('.company-data').hide();
    // window.wizard.setValid(2)
    $list.html('');
    $list.append('<option value="-1" >Kies uw locatie</option>')
    _.each(kvkCompanies, (entry, index) => {
      var address = formatKvKEntry(entry);
      if(address) $list.append(`<p>
      <option value="${index}" >${address}</option>
    </p>`)
    });
    var elems = document.querySelectorAll('#company-choices');
    M.FormSelect.init(elems);
  });

  window.wizard.addStepValidation(2, function (cb) {
    let $company = $('#step2').serializeObject();
    $company.kvk = kvk;
    api('registration/validate/company', $company, function (resp) {
      if (!resp.success) {
        showValidation(resp.errors)
      } else {
        window.wizard.setValid(2);
        cb()
      }
    })
  });
  window.wizard.addStepValidation(3, function (cb) {
    api('registration/validate/user', $.extend($('#step2').serializeObject(), $('#step3').serializeObject(), {'kvk_company': $('#kvk').val()}), function (resp) {
      if (!resp.success) {
        showValidation(resp.errors)
      } else {
        window.wizard.setValid(3);
        cb()
      }
    })
  });
  window.wizard.addStepAction(4, function () {
    signaturePad = new SignaturePad(document.getElementById('signature'));
    let data = {};
    data.company = $('#step2').serializeObject();
    data.company.kvk = kvk;
    data.user = $('#step3').serializeObject();
    data.user_type = user_type;
    //
    // // XMLHttpRequest for blob file
    // let oReq = new XMLHttpRequest();
    // oReq.open("POST", BASE_URL + "/registration/validate/agreement", true);
    // oReq.setRequestHeader('Accept', 'application/json');
    // oReq.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    // oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    // oReq.responseType = "arraybuffer";
    //
    // oReq.onload = function(oEvent) {
    //   let arrayBuffer = oReq.response;
    //
    //   // If you want to use the pdf in your DOM:
    //   let blob = new Blob([arrayBuffer], {type: "application/pdf"});
    //   pdfUrl = URL.createObjectURL(blob);
    // };
    // let jsonData = JSON.stringify(data);
    // oReq.send(jsonData);
  });

  window.wizard.addStepValidation(4, function (cb) {
    let privacy = false;
    let condition = false;
    let signature = false;
    let processor = false;
    let agreement = false;
    $('.helper-text').hide();

    privacy = $('#privacy').prop('checked');
    condition = $('#condition').prop('checked');
    processor = $('#processor').prop('checked');
    agreement = $('#agreement').prop('checked');
    if(mode === 'img') {
      signature =  $('#uploaded-img').attr('src');
    } else {
      signature = !signaturePad.isEmpty()
    }
    if(!privacy) {
      $('#helper-privacy').show();
    }
    if(!condition) {
      $('#helper-condition').show();
    }
    if (!signature) {
      $('#helper-signature').show();
    }
    if (!processor) {
      $('#helper-processor').show();
    }
    if (!agreement) {
      $('#helper-agreement').show();
    }
    if(privacy && condition && signature && processor && agreement) {
      if(mode === "img") {
        base64 = $('#uploaded-img').attr('src');
      } else {
        base64 = signaturePad.toDataURL();
      }
      window.wizard.setValid(4);
      cb();
    }

  });
  window.wizard.addStepAction(5, function () {
    let preview = {};
    preview.company = $('#step2').serializeObject();
    preview.company.kvk = kvk;
    preview.user = $('#step3').serializeObject();
    let $utable = $('#user_preview_table');
    let $ctable = $('#company_preview_table');
    let name = preview.user.fname;
    let html = '';
    $ctable.empty(); // empty the company table
    $utable.empty(); // empty the user table
    $ctable.append(makeRow('Bedrijf'));
    $ctable.append(makeRow(preview.company.name, 'Bedrijfsnaam' ));
    $ctable.append(makeRow(preview.company.visit_street + ' ' + preview.company.visit_housenumber + preview.company.visit_housenumber_addition, 'Adres' ));
    $ctable.append(makeRow(preview.company.visit_zipcode, 'Postcode' ));
    $ctable.append(makeRow(preview.company.visit_city, 'Plaats' ));
    $utable.append(makeRow('Persoonlijk'));
    $utable.append(makeRow(preview.user.fname + ' ' + preview.user.mname + ' ' + preview.user.lname, 'Naam'));
    $utable.append(makeRow(preview.user.email, 'E-mail'));
    $utable.append(makeRow(preview.user.phone, 'Telefoon'));
    $('.name-container').html(name);
    // this.$el.find('#register-preview').html(html);
  });
  $('.search-kvk').on('click', function () {
    var type = $(this).attr('data-type'),
      data = {};
    if (type === 'kvk') {
      data.kvk = $('#kvk').val();
    } else {
      data.city = $('#city').val();
      data.name = $('#name').val();
    }
    api('api/kvkcheck', data, function (resp) {
      if (!resp.success) {
        if (resp.errors) {
          showValidation(resp.errors)
        }
      } else {
        kvkCompanies = resp.data;
        wizard.setValid(1);
        wizard.next();
      }
    })
  });
  var $body = $('body');

  $('#processor_link').on('click', () => {
    if(loading_processor) {
      return;
    }
    loading_processor = true;
    let data = {};
    data.company = $('#step2').serializeObject();
    data.company.kvk = kvk;
    data.user = $('#step3').serializeObject();
    data.user_type = user_type;
    data.sign_function = $('#sign_function').val();
    data.sign_place = $('#sign_place').val();
    // XMLHttpRequest for blob file
    let oReq = new XMLHttpRequest();
    oReq.open("POST", BASE_URL + "/registration/validate/processor", true);
    oReq.setRequestHeader('Accept', 'application/json');
    oReq.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    oReq.responseType = "arraybuffer";
    $('.processor-loader').show();
    oReq.onload = function(oEvent) {
      loading_processor = false;
      let arrayBuffer = oReq.response;
      $('.processor-loader').hide();

      // If you want to use the pdf in your DOM:
      let blob = new Blob([arrayBuffer], {type: "application/pdf"});
      pdfUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = pdfUrl;
      a.download = "overeenkomst.pdf";
      document.body.appendChild(a);
      a.click();

      // var win = window.open(pdfUrl);

    };
    let jsonData = JSON.stringify(data);
    oReq.send(jsonData);
  });
  $('#agreement_link').on('click', () => {
    if(loading_agreement) {
      return;
    }
    loading_agreement = true;

    let data = {};
    data.company = $('#step2').serializeObject();
    data.company.kvk = kvk;
    data.user = $('#step3').serializeObject();
    data.user_type = user_type;
    data.sign_function = $('#sign_function').val();
    data.sign_place = $('#sign_place').val();
    data.subscriptionId = subscriptionId;
    // XMLHttpRequest for blob file
    let oReq = new XMLHttpRequest();
    oReq.open("POST", BASE_URL + "/registration/validate/agreement", true);
    oReq.setRequestHeader('Accept', 'application/json');
    oReq.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    oReq.responseType = "arraybuffer";
    $('.agreement-loader').show();

    oReq.onload = function(oEvent) {
      let arrayBuffer = oReq.response;
      $('.agreement-loader').hide();
      loading_agreement = false;

      // If you want to use the pdf in your DOM:
      let blob = new Blob([arrayBuffer], {type: "application/pdf"});
      pdfUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = pdfUrl;
      a.download = "overeenkomst.pdf";
      document.body.appendChild(a);
      a.click();

    };
    let jsonData = JSON.stringify(data);
    oReq.send(jsonData);
  });
  $('.upload-image').on('click', () => {
    if(mode === 'draw') $('#image').click();
    else {
      mode = 'draw';
      $('#signature, .reset').show();
      $('#uploaded-img').hide();
      $('.upload-image').html('Plaatje uploaden');
      $('#image').val('')
    }
  });

  $('#image').on('change', function (e) {
    const allowed = {
      'image/jpeg': true,
      'image/jpg': true,
      'image/png': true,
    };
    if(this.files[0].size > 100 * 1024) {
      alert('Kies een afbeelding van maximaal 100 kb');
      $(this).val('');
      return
    }
    if(!allowed[this.files[0].type]) {
      alert('Kies een png of jpeg afbeelding');
      $(this).val('');
      return
    }
    getBase64(this.files[0], (b64) => {
      $('#signature, .reset').hide();
      $('#uploaded-img').attr('src', b64).show();
      mode = 'img';
      $('.upload-image').html('Naar tekenen');
    });
  });
  $('.reset').on('click', () => {
    signaturePad.clear();
  });
  $body.on('change', '#company-choices', function () {
    $('#kvk-select').html('');
    var $el = $(this),
      index = parseInt($el.val()),
      $name = $('.company-data input[name="name"]'),
      $street = $('#visit_street'),
      $housenumber = $('#visit_housenumber'),
      $housenumber_addition = $('#visit_housenumber_addition'),
      $visit_zipcode = $('#visit_zipcode'),
      $visit_city = $('#visit_city'),
      all = [$name, $street, $housenumber, $housenumber_addition, $visit_zipcode, $visit_zipcode, $visit_city];
    if (index !== -1) {
      var cur = kvkCompanies[index];
      kvk = cur.kvkNumber;
      // debugger;
      $name.val(cur.tradeNames.businessName);
      $street.val(getAddressPart(cur, 'street'));
      $housenumber.val(getAddressPart(cur, 'houseNumber'));
      $housenumber_addition.val(getAddressPart(cur, 'houseNumberAddition'));
      $visit_zipcode.val(getAddressPart(cur, 'postalCode'));
      $visit_city.val(getAddressPart(cur, 'city'));
      M.updateTextFields();
    } else {
      $(all).each(function () {
        $(this).val('')
      });
      M.updateTextFields();
    }
    $el.parents('.step-tab-panel').find('.company-data').show();
  });
  $body.on('input', '#step3 input:not(#password-confirm)', function () {
    var data = $.extend($('#step2').serializeObject(), $('#step3').serializeObject());
    delete data.password;
    delete data.password_confirmation;
    data.kvk = $('#kvk').val();
    // var result = zxcvbn($('#password').val(), Object.values(data));
    // $('.meter').attr('data-value', result.score);
    // $('#score').html(result.score);
    var score = checkPassword($('#password').val());
    $('.meter').attr('data-value', score);
    $('#score').html(score);
  });

  $body.on('click', '.btn.finish', function (el) {
    var data = {};
    data.company = $('#step2').serializeObject();
    data.company.kvk = kvk;
    data.token = token;
    data.user = $('#step3').serializeObject();
    data.user_type = user_type;
    data.subscription_id = subscriptionId;
    data.sign_function = $('#sign_function').val();
    data.sign_place = $('#sign_place').val();
    data.image = base64;
    $(el.currentTarget).attr("disabled", true);
    $(el.currentTarget).html('Even geduld, uw aanvraag wordt verwerkt');
    $.ajax({
      url: registrationUrl,
      data: data,
      type: 'POST',
      success: function (resp) {
        $('.register-card').hide();
        $('.success-card').show();
      },
      error: function (resp) {
        $(el.currentTarget).html('Voltooien');

        $(el.currentTarget).attr("disabled", false);
        M.Toast({html: 'Server fout'})
      }
    })

  });

});


// WEBPACK FOOTER //
// ./resources/assets/js/registration_new.js